import "./assets/styles/styles.scss"
import "./index.scss"

const searchBox = document.querySelector(".search-box")
const searchIcon = document.querySelector("#search-icon")

const navBar = document.querySelector(".nav-bar")
const menuIcon = document.querySelector("#menu-icon")

const header = document.querySelector("header")

searchIcon.addEventListener("click", () => {
  searchBox.classList.toggle("active")
})

menuIcon.addEventListener("click", () => {
  navBar.classList.toggle("active")
})

window.addEventListener("scroll", () => {
  header.classList.toggle("active", scrollY > 0)
})

window.addEventListener("click", (event) => {
  if (!menuIcon.contains(event.target)) {
    navBar.classList.remove("active")
  }
  if (!searchIcon.contains(event.target) && !searchBox.contains(event.target)) {
    searchBox.classList.remove("active")
  }
})

window.addEventListener("scroll", () => {
  navBar.classList.remove("active")
  searchBox.classList.remove("active")
})
